import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingQualityControlComponent } from "./booking-quality-control.component";
import { CardModule } from "libraries/ui_card/card.module";
import { BookingQualityControlDataModule } from "libraries/component/booking-quality-control-data/booking-quality-control-data.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [
      BookingQualityControlComponent
  ],
    imports: [
        CommonModule,
        CardModule,
        BookingQualityControlDataModule,
        FontAwesomeModule
    ],
  exports: [
      BookingQualityControlComponent
  ]
})
export class BookingQualityControlModule { }
